import React from 'react';
import YoutubePlaylistItemsApi from '../../components/admin/YoutubePlaylistItemsApi';

const YoutubePlaylistItemsApiPage = () => {
  return <YoutubePlaylistItemsApi />;
};

export default YoutubePlaylistItemsApiPage;
